import qs from "qs";
import axios from "axios";
import { Dialog, Toast } from "vant";
import Cookies from "js-cookie";
import { REDIRECT_URI, APP_ID } from "../config/global.js";

axios.defaults.timeout = 30000; // 请求超时
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
// axios.defaults.withCredentials = true; // 允许跨域携带cookie
// axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

function redirectToFeishuAuth(targetUrl) {
  const callback = encodeURIComponent(REDIRECT_URI);
  const state = `erp_login_${Date.now()}`;
  const redirectTarget = targetUrl || window.location.href;
  // encode redirect target into state so backend (不同域名) 能读取并跳回
  try {
    const stateObj = { ru: redirectTarget, t: Date.now() };
    const stateStr = btoa(unescape(encodeURIComponent(JSON.stringify(stateObj))));
    window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=${APP_ID}&redirect_uri=${callback}&state=${encodeURIComponent(stateStr)}`;
  } catch (e) {
    // fallback: store in localStorage (works when same origin)
    localStorage.setItem("redirect_url", redirectTarget);
    window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=${APP_ID}&redirect_uri=${callback}&state=${state}`;
  }
}

// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    // 兼容旧逻辑的 Authorization（如果有用到）
    const legacy = localStorage.getItem("token");
    if (!isEmpty(legacy)) {
      config.headers["Authorization"] = "Bearer " + legacy;
    }

    // 统一取 token：
    // 优先 cookie（后端回调写 cookie，更“权威”；localStorage 可能残留旧 token 导致死循环）
    let stoToken = Cookies.get("sto_user_token") || "";
    if (!stoToken) {
      stoToken = window.localStorage.getItem("sto_user_token") || "";
    } else {
      // 同步回 localStorage，减少后续页面逻辑误判未登录
      try {
        window.localStorage.setItem("sto_user_token", stoToken);
      } catch (e) {
        // ignore
      }
    }

    if (stoToken) {
      config.headers["token"] = stoToken;
    }

    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(res) {
    // sto    token失效
    if (res.data.code == 10401) {
      window.localStorage.removeItem("sto_user_token");
      // 同时清 cookie（否则 cookie 里残留旧 token，会一直携带导致无限 10401）
      try {
        const cookieDomain = window.location.hostname.endsWith("sys.yksto.com")
          ? ".sys.yksto.com"
          : window.location.hostname;
        Cookies.remove("sto_user_token", { domain: cookieDomain, path: "/" });
      } catch (e) {
        // ignore
      }
      window.localStorage.setItem("redirect_url", window.location.href);
      if (window.h5sdk) {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
      } else {
        Dialog.confirm({
          title: "身份失效",
          message: "身份信息失效，请重新授权飞书登录",
        })
          .catch(() => {
            window.localStorage.removeItem("sto_user_token");
          });
      }
      redirectToFeishuAuth();
      return;
    }

    if (res.data.code == 10403) {
      Dialog.alert({
        title: "权限不足",
        message: res.data.msg,
      }).then(() => {
        // console.log(res)
        // window.location.href = REDIRECT_URI
      });
      return Promise.reject(res);
    }

    return res;
  },
  function(err) {
    if (err && err.data && err.data.code == 401 && err.data.msg == "generate access_token fail") {
      window.localStorage.removeItem("sto_user_token");
      window.localStorage.setItem("redirect_url", window.location.href);
      redirectToFeishuAuth();
    }
    if (err.response && err.response.data && err.response.data.code == 401) {
      Toast(err.response.data.msg);
    }
    // 对响应错误做点什么
    return Promise.reject(err);
  }
);

/*对象转json*/
export function toJson(data) {
  var json = qs.stringify(data);
  return json;
}

/*判断是否为空*/
export function isEmpty(str) {
  if (str === "" || str === null || str === undefined) {
    return true;
  }
  return false;
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function deletes(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(params))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}


export async function downFile(url, params, config, filename = '数据模板.xlsx'){
	axios
		.get(url, {
		params,
		headers: {'Content-Type':'application/x-www-form-urlencoded'},
		responseType: 'arraybuffer',
		...config
	})
	.then(async(resp)=> {
		const { data }= resp;
		const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }));
		const link = document.createElement('a');
		link.style.display = 'none';
		link.href = url;
		link.setAttribute('download', filename); // 设置下载的文件名
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	})
	.catch((e)=> {
		console.log(e	)
	})
	.finally(()=>{
		
	})
}
	//Vue.use(axios)
